import {
  renderMainLeftCell,
  renderColumnGaps,
  renderMainRightCell,
  renderSectionHeaderAsOfDate,
  renderRowGaps
} from '../helpers';
import format from '_shared_/plugins/format.js';
const $format = format.formatHelpers;

export const renderValuationHeaderRow = headers => {
  let rowString = `<tr>`;
  rowString += renderColumnGaps();
  headers.forEach(header => {
    rowString += renderMainLeftCell(header);
  });
  rowString += `</tr>`;
  return rowString;
};

export const valuationModule = data => {
  let valuationString = ``;
  valuationString += renderSectionHeaderAsOfDate('Valuation', data.asOfDate);
  valuationString += renderRowGaps();
  valuationString += renderValuationHeaderRow(data.headers);
  valuationString += `<tr>`;
  valuationString += renderMainLeftCell('Fund');
  valuationString += renderMainRightCell(`${$format.formatExtraZero(data.mstarPriceToBook)}`);
  valuationString += renderMainRightCell(`${$format.formatExtraZero(data.mstarPriceToCash)}`);
  valuationString += renderMainRightCell(`${$format.formatExtraZero(data.mstarPriceToEarnings)}`);
  valuationString += `</tr>`;
  valuationString += `<tr>`;
  valuationString += renderMainLeftCell(data.cgIndexName);
  valuationString += renderMainRightCell(`${$format.formatExtraZero(data.indexPriceToBook)}`);
  valuationString += renderMainRightCell(`${$format.formatExtraZero(data.indexPriceToCash)}`);
  valuationString += renderMainRightCell(`${$format.formatExtraZero(data.indexPriceToEarnings)}`);
  valuationString += `</tr>`;
  valuationString += renderRowGaps(2);
  return valuationString;
};
